export default {
    notifications: '',
    notificationsList: [],
};